exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".volume__mute__30QM4{text-align:left}.volume__mute__30QM4 .volume__icon__36H0s{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;opacity:.8;font-size:17px}.volume__mute__30QM4.volume__at-full-screen__25W9z .volume__icon__36H0s{font-size:26px}.volume__mute__30QM4:hover .volume__icon__36H0s{opacity:1}.volume__mute__volume__1cbtc{position:absolute;left:50%;bottom:100%;display:none;width:24px;height:40px;margin-left:-12px;padding-top:8px;background-color:#1a1a1a}.volume__mute--focused__1I6eo .volume__mute__volume__1cbtc,.volume__mute__30QM4:hover .volume__mute__volume__1cbtc{display:block}.volume__mute__track__vZYGk{box-sizing:content-box;position:relative;height:86px;width:2px;padding:2px 7px}.volume__level__1Z_uU{background-color:hsla(207,7%,70%,.8)}.volume__level-fill__3sApa:after{content:\"\";position:absolute;top:-5px;right:-5px;width:12px;height:12px;background-color:#fff;border-radius:50%}.volume__level-input__1tGaJ{width:12px;left:-5px;right:-5px}", ""]);

// exports
exports.locals = {
	"mute": "volume__mute__30QM4",
	"icon": "volume__icon__36H0s",
	"at-full-screen": "volume__at-full-screen__25W9z",
	"atFullScreen": "volume__at-full-screen__25W9z",
	"mute__volume": "volume__mute__volume__1cbtc",
	"muteVolume": "volume__mute__volume__1cbtc",
	"mute--focused": "volume__mute--focused__1I6eo",
	"muteFocused": "volume__mute--focused__1I6eo",
	"mute__track": "volume__mute__track__vZYGk",
	"muteTrack": "volume__mute__track__vZYGk",
	"level": "volume__level__1Z_uU",
	"level-fill": "volume__level-fill__3sApa",
	"levelFill": "volume__level-fill__3sApa",
	"level-input": "volume__level-input__1tGaJ",
	"levelInput": "volume__level-input__1tGaJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/controls/volume/volume.styl
// module id = 1308
// module chunks = 0 1 2 3